import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d1868bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://github.com/schouffy/gamedev-portfolio",
    target: "blank"
  }, "Portfolio"),
  /*#__PURE__*/_createTextVNode(" by schouffy")
], -1))
const _hoisted_3 = { class: "right" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "mailto:raquelgarciaguillem@gmail.com" }, "raquelgarciaguillem@gmail.com", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createTextVNode("Reach me at "),
      _hoisted_4,
      _createTextVNode(" or "),
      _createVNode(_component_router_link, { to: "/contact" }, {
        default: _withCtx(() => [
          _createTextVNode("through here")
        ]),
        _: 1
      })
    ])
  ]))
}